import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/AdminCss/admin_users.css";
import AdminSidebar from "./AdminSidebar";
import axios from "axios";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";
import toast from "react-hot-toast";

export const base_url = process.env.REACT_APP_API_URL;

const AgentWhitelist = () => {
  const navigate= useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [modal, setModal] = useState({ action: null, id: null });
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [error, setError] = useState();
  const [match, setMatch] = useState();
  const [permit, setPermit] = useState([]);
  const [agents, setAgents] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const [nextAgentId, setNextAgentId] = useState("Agent1");
  const [formData, setFormData] = useState({
    agentid: "",
    agentname: "",
    username: "",
    password: "",
    plain_password:'',
    confirmpassword:'',
    phone: "",
    wallet: 0,
    amount: 0,
    status: "Active",
    role:'agent',
    time: "",
    api_type: [],
  });

  const { getRoles } = useContext(AuthContext);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleModal = (action, id) => {
    setModal({ action, id });
    if (action === "edit-agent" && id) {
      const agent = agents.find((a) => a.agentid === id);
      if (agent) {
        setFormData({
          ...agent,
          api_type: agent.api_type
            ? agent.api_type.split(",").map((x) => x.trim())
            : []
        });
      }
    } else {
      setFormData({
        agentid: nextAgentId,
        agentname: "",
        username: "",
        password: "",
        plain_password:'',
        confirmpassword:'',
        phone: "",
        wallet: 0,
        amount: 0,
        status: "Active",
        role: "agent",
        time: "",
      });
    }
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "api_type") {
      // If it's a checkbox for api_type
      let updatedApiTypes = [...(formData.api_type || [])];

      if (checked) {
        // Add value if not already in array
        if (!updatedApiTypes.includes(value)) {
          updatedApiTypes.push(value);
        }
      } else {
        // Remove value if unchecked
        updatedApiTypes = updatedApiTypes.filter((item) => item !== value);
      }

      setFormData({
        ...formData,
        api_type: updatedApiTypes,
      });
    } else {
      // Default behaviour for other fields
      const updatedForm = { ...formData, [name]: value };
      setFormData(updatedForm);

      const { plain_password, confirmpassword } = updatedForm;

      if (modal.action === "add-agent") {
        if (plain_password && confirmpassword) {
          if (plain_password === confirmpassword) {
            setMatch(""); // ✅ passwords match
          } else {
            setMatch("Password and Confirm Password do not match");
          }
        } else {
          setMatch("");
        }
      }
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const auth = localStorage.getItem("admin");
    try {
      if(!formData.agentid || formData.agentid === ''){
        return toast.error("Agent id is required");
      }

      if(!formData.agentname || formData.agentname === ''){
        return toast.error("Agent name is required");
      }

      if(!formData.username || formData.username === ''){
        return toast.error("username is required");
      }

      if(!formData.plain_password || formData.plain_password === ''){
        return toast.error("password is required");
      }

      if(!formData.phone || formData.phone === ''){
        return toast.error("phone is required");
      }

      if(!formData.role || formData.role === ''){
        return toast.error("role is required");
      }


      let response;
      if (modal.action === "add-agent") {
        response = await axios.post(`${base_url}/admin/addAgents`, formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`
          },
        });
      } else if (modal.action === "edit-agent") {
        response = await axios.post(`${base_url}/admin/editAgents`, formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`
          },

        });
      }
      if(response?.data.success){
        toast.success(response?.data?.message);
        setShowModal(false);
        fetchAgents();
      }else{
        toast.error(response?.data?.message);
      }
      
    } catch (err) {
      console.log(err);
    }
  };

  const fetchRoles = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");
    try {
      const roles = await getRoles(auth, role);
      let allPermit = [];
      Object.values(Object.values(roles[0])[0]).forEach((roleObj) => {
        Object.values(roleObj).forEach((perm) => {
          allPermit.push(...Object.values(perm));
        });
      });
      setPermit(allPermit);
    } catch (error) {
      setError(error.message);
    }
  }, []);

  const fetchAgents = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.get(`${base_url}/admin/getAgents`, {
        headers: { Authorization: `${auth}` }
      });

      if (response?.data?.success) {
        const data = response?.data?.agents || [];
        setAgents(data);
        setAllAgents(data);

        if (data.length > 0) {
          // extract numeric part after "Agent"
          const maxNum = Math.max(
            ...data.map(a => {
              const match = a?.agentid?.match(/Agent(\d+)/);
              return match ? parseInt(match[1], 10) : 0;
            })
          );
          setNextAgentId(`Agent${maxNum + 1}`);
        } else {
          setNextAgentId("Agent1"); // first agent
        }
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleSearch= (e) => {
    try{
      // console.log(e.target.value);
      const search= e.target.value.toLowerCase();

      if(search=== ''){
        setAgents(agents);
        return;
      }

      const filteredData = allAgents?.filter((value) => {
        if(value.agentid.toLowerCase().includes(search) || value.agentname.toLowerCase().includes(search)){
          return value;
        }
        return false;
      });

      setAgents(filteredData);


    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    fetchRoles();
    fetchAgents();
  }, [fetchRoles, fetchAgents]);

  

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (error) return <p className="text-danger">{error}</p>;

  return (
    <>
      <div className="wrapper bg-light min-vh-100">
        <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
        <AdminHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />

        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
        >
          <div className="px-3 py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h1 className="h4 text-dark">
                <i className="fa fa-users text-primary me-2" />
                Agents
              </h1>
              <button
                onClick={() => handleModal("add-agent", null)}
                className="btn btn-primary"
              >
                <i className="fa fa-plus me-1" /> Add Agent
              </button>
            </div>

            <div className="w-100 my-3 rounded"><input type="text" placeholder="Enter Agent ID or Agent Name" name="search" className="form-control rounded" onChange={(e)=>handleSearch(e)} /></div>

            <div className="table-responsive bg-white shadow-sm rounded">
              <table className="table table-striped table-hover bg-gray">
                <thead className="table-light bg-gray">
                  <tr className="text-center border">
                    <td className="border fw-bold">Agent ID</td>
                    <td className="border fw-bold">Agent Name</td>
                    <td className="border fw-bold">Username</td>
                    <td className="border fw-bold">Password</td>
                    <td className="border fw-bold">Phone</td>
                    <td className="border fw-bold">Wallet</td>
                    <td className="border fw-bold">Status</td>
                    <td className="border fw-bold">API Type</td>
                    <td className="border fw-bold">Date</td>
                    <td className="border fw-bold">Action</td>
                  </tr>
                </thead>
                <tbody>
                  {agents.map((agent) => (
                    <tr key={agent.agentid} className="text-center border">
                      <td className="border">{agent.agentid}</td>
                      <td className="border">{agent.agentname}</td>
                      <td className="border">{agent.username}</td>
                      <td className="border">{agent.plain_password}</td>
                      <td className="border">{agent.phone}</td>
                      <td className="border">{agent.wallet}</td>
                      <td className="border">{agent.status}</td>
                      <td className="border">{agent.api_type}</td>
                      <td className="border">{(agent.time)?.replace('T',', ').slice(0, 10)}</td>
                      <td className="d-flex gap-2 justify-content-end">
                        <button
                          onClick={() =>
                            handleModal("edit-agent", agent.agentid)
                          }
                          className="btn btn-sm btn-outline-primary border"
                        >
                          Edit
                        </button>

                        <button
                        onClick={() =>
                            navigate('/admin/company', { state: {id: agent?.agentid}})
                          }
                          className="btn btn-sm btn-outline-success border"
                        >Compnay</button>

                        <button
                        onClick={() =>
                            navigate('/admin/account', { state: {id: agent?.agentid}})
                          }
                          className="btn btn-sm btn-outline-danger border"
                        >Acc stmt</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4 overflow-hidden">
              
              {/* Modal Header with Gradient */}
              <div
                className="modal-header text-white"
                style={{
                  background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                  borderBottom: "none",
                }}
              >
                <h5 className="modal-title fw-bold">
                  {modal.action === "add-agent" ? "➕ Add New Agent" : "✏️ Edit Agent"}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body p-4 bg-light">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    {match && (
                      <div className='text-center text-red'>{match}</div>
                    )}

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Agent ID</label>
                      <input type="text" placeholder="Enter Agent ID" name="agentid" value={formData.agentid} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)} readOnly />
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">AgentName</label>
                      <input type="text" placeholder="Enter agentname" name="agentname" value={formData.agentname} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">UserName</label>
                      <input type="text" placeholder="Enter username" name="username" value={formData.username} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}   // 👈 toggle input type
                          placeholder="Enter password"
                          name="plain_password"
                          value={formData.plain_password}
                          className="form-control rounded-pill shadow-sm pe-5"
                          onChange={(e) => handleChange(e)}
                        />
                        <i
                          className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"} position-absolute`}
                          style={{ right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}
                        ></i>
                      </div>
                    </div>

                    {modal.action === "add-agent" &&(<div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword1 ? "text" : "password"}
                          placeholder="Enter password"
                          name="confirmpassword"
                          value={formData.confirmpassword}
                          className="form-control rounded-pill shadow-sm pe-5"
                          onChange={(e) => handleChange(e)}
                        />
                        <i
                          className={`fa ${showPassword1 ? "fa-eye" : "fa-eye-slash"} position-absolute`}
                          style={{ right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                          onClick={() => setShowPassword1(!showPassword1)}
                        ></i>
                      </div>
                    </div>)}

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Phone</label>
                      <input type="text" placeholder="Enter phone" name="phone" value={formData.phone} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)} maxLength={10} readOnly={modal.action === "edit-agent"} />
                    </div>

                    {/* <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Secret Key</label>
                      <input type="text" placeholder="Enter Agent ID" name="secret_key" value={formData.secret_key} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Verify Key</label>
                      <input type="text" placeholder="Enter Agent ID" name="verify_key" value={formData.verify_key} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div> */}

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Wallet</label>
                      <input type="text" placeholder="Enter wallet" name="wallet" value={formData.wallet} className="form-control rounded-pill shadow-sm" readOnly/>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Amount</label>
                      <input type="text" placeholder="Enter wallet" name="amount" value={formData.amount} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-4">
                      <label className="form-label fw-semibold text-secondary">API Access</label>
                      <div>
                        <label className="me-3 text-black">
                          <input
                            type="checkbox"
                            name="api_type"
                            value="casino"
                            checked={formData.api_type?.includes("casino")}
                            onChange={handleChange}
                          />{" "}
                          Casino
                        </label>
                        <label className="me-3 text-black">
                          <input
                            type="checkbox"
                            name="api_type"
                            value="sports"
                            checked={formData.api_type?.includes("sports")}
                            onChange={handleChange}
                          />{" "}
                          Sports
                        </label>
                      </div>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">
                        Status
                      </label>

                      <select
                        value={formData.status}
                        name="status"
                        onChange={handleChange} // ✅ Moved here
                        className="form-select rounded shadow-sm border border-secondary"
                        style={{
                          backgroundColor: "#fff",
                          fontWeight: "500",
                          padding: "6px 8px",
                        }}
                      >
                        <option value="Active">Active</option>
                        <option value="InActive">InActive</option>
                        <option value="Suspended">Suspended</option>
                      </select>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Role</label>
                      <input type="text" placeholder="Enter Role" name="role" value={formData.role} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)} readOnly={modal.action === "edit-agent"} />
                    </div>


                    {modal.action !== "add-agent" && (<div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Time</label>
                      <input type="text"  name="time" value={(formData.time)?.slice(0, 10)} className="form-control rounded-pill shadow-sm" readOnly/>
                    </div>)}

                    {/* <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">IP</label>
                      <input type="text" placeholder="Enter Agent ID" name="ip" value={formData.ip} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Project Name</label>
                      <input type="text" placeholder="Enter Agent ID" name="project_name" value={formData.project_name} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Project URL</label>
                      <input type="text" placeholder="Enter Agent ID" name="project_url" value={formData.project_url} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div> */}




                    {/* {Object.entries(formData).map(([key, value]) =>
                      key !== "agentid" || modal.action === "edit-agent" ? (
                        <div
                          className="col-md-6"
                          key={key}
                          style={{ animation: "fadeInUp 0.3s ease" }}
                        >
                          <label className="form-label text-capitalize fw-semibold text-secondary">
                            {key === 'time' ? '' : key.replace("_", " ")}
                          </label>
                          <input
                            type={key === "password" ? "password" : key === 'time' ? '' : "text"}
                            name={key === 'time' ? '' : key}
                            value={value}
                            onChange={handleChange}
                            // readOnly={["agentid", "time", "ip"].includes(key)}
                            className={`form-control rounded-pill shadow-sm`}
                          />
                        </div>
                      ) : null
                    )} */}
                  </div>

                  {/* Footer Actions */}
                  <div className="text-end mt-4">
                    <button
                      type="button"
                      onClick={() => setShowModal(false)}
                      className="btn btn-outline-secondary rounded-pill px-4 me-2 shadow-sm"
                    >
                      ❌ Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn text-white rounded-pill px-4 shadow-sm"
                      style={{
                        background: "linear-gradient(135deg, #ff512f 0%, #dd2476 100%)",
                        border: "none",
                      }}
                    >
                      💾 Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default AgentWhitelist;


